/*
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */
export enum VizType {
  Area = 'echarts_area',
  Bar = 'echarts_timeseries_bar',
  BigNumber = 'big_number',
  BigNumberTotal = 'big_number_total',
  BigNumberPeriodOverPeriod = 'pop_kpi',
  BoxPlot = 'box_plot',
  Bubble = 'bubble_v2',
  Bullet = 'bullet',
  Calendar = 'cal_heatmap',
  Chord = 'chord',
  Compare = 'compare',
  CountryMap = 'country_map',
  DistBar = 'dist_bar',
  EventFlow = 'event_flow',
  Funnel = 'funnel',
  Gauge = 'gauge_chart',
  Graph = 'graph_chart',
  Handlebars = 'handlebars',
  Heatmap = 'heatmap_v2',
  Histogram = 'histogram_v2',
  Horizon = 'horizon',
  LegacyArea = 'area',
  LegacyBar = 'bar',
  LegacyBubble = 'bubble',
  LegacyHeatmap = 'heatmap',
  LegacyHistogram = 'histogram',
  LegacyLine = 'line',
  LegacySankey = 'sankey',
  Line = 'echarts_timeseries_line',
  MapBox = 'mapbox',
  MixedTimeseries = 'mixed_timeseries',
  PairedTTest = 'paired_ttest',
  ParallelCoordinates = 'para',
  Partition = 'partition',
  Pie = 'pie',
  PivotTable = 'pivot_table_v2',
  Radar = 'radar',
  Rose = 'rose',
  Sankey = 'sankey_v2',
  Scatter = 'echarts_timeseries_scatter',
  SmoothLine = 'echarts_timeseries_smooth',
  Step = 'echarts_timeseries_step',
  Sunburst = 'sunburst_v2',
  Table = 'table',
  TimePivot = 'time_pivot',
  TimeTable = 'time_table',
  Timeseries = 'echarts_timeseries',
  Tree = 'tree_chart',
  Treemap = 'treemap_v2',
  Waterfall = 'waterfall',
  WordCloud = 'word_cloud',
  WorldMap = 'world_map',
}
